import React, { useState } from "react";
import CertificationSkillsDevelopmentFlow from "../../assets/diagrams/certification_skills_development_flow.png";
import PublishApiFlow from "../../assets/diagrams/publish_api_flow.png";
import Footer from "../components/developer_footer.jsx"; // Import the Footer component
import Header from "../components/developer_header.jsx"; // Import the Header component

const GetStartedLayout = () => {
  // State for notification
  const [notification, setNotification] = useState({
    visible: false,
    message: ""
  });

  // Function to show notification
  const showNotification = (message) => {
    setNotification({ visible: true, message });
    // Hide notification after 3 seconds
    setTimeout(() => {
      setNotification({ visible: false, message: "" });
    }, 3000);
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      {/* Notification component */}
      {notification.visible && (
        <div className="fixed top-4 right-4 bg-blue-500 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-md shadow-lg z-50 transition-opacity duration-300 text-sm sm:text-base">
          {notification.message}
        </div>
      )}
      
      <Header/>

      {/* Main Content */}
      <main className="flex-grow">
        {/* Getting Started Section */}
        <section className="container mx-auto px-4 sm:px-6 py-8 sm:py-12 text-center">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-3 sm:mb-4">GETTING STARTED WITH OPENAPIPASS</h2>
          <p className="text-gray-600 mb-6 sm:mb-8 max-w-3xl mx-auto text-justify text-sm sm:text-base px-4 sm:px-0">
            Welcome to OPENAPIPASS, where software developers, IHLs, and Industry may attain NETS QR, NETS Click, 
            and eNETS Certification for full-stack FinTech skills development courses or industry projects. 
            Collaborating IHLs and Industry may publish joint APIs for OPENAPIPASS software developer community.
          </p>

          {/* Diagrams Section */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-8 px-4 sm:px-0">
            {/* Left Diagram */}
            <div className="bg-white shadow-md rounded-lg p-4 sm:p-6 flex flex-col justify-between">
              <div>
                <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">Full-Stack FinTech Skills Development</h3>
                <div className="h-48 sm:h-64 flex items-center justify-center mb-4 sm:mb-6">
                  <img
                    src={CertificationSkillsDevelopmentFlow}
                    alt="NETS Micro-Credentials Certificate"
                    className="max-h-full max-w-full object-contain"
                  />
                </div>
              </div>
              <a
                href="/certification-journey"
                className="bg-blue-600 hover:bg-blue-700 text-white py-2 sm:py-3 px-4 sm:px-6 rounded-md text-base sm:text-lg font-medium block text-center mt-3 sm:mt-4 transition-all hover:shadow-lg"
              >
                Get Started
              </a>
            </div>

            {/* Right Diagram */}
            <div className="bg-white shadow-md rounded-lg p-4 sm:p-6 flex flex-col justify-between">
              <div>
                <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">Joint IHLs-Industry APIs</h3>
                <div className="h-48 sm:h-64 flex items-center justify-center mb-4 sm:mb-6">
                  <img
                    src={PublishApiFlow}
                    alt="Publish Joint IHL-Industry APIs"
                    className="max-h-full max-w-full object-contain"
                  />
                </div>
              </div>
              <button
                onClick={() => showNotification("Coming Soon! This feature will be available in the future.")}
                className="bg-gray-800 hover:bg-gray-900 text-white py-2 sm:py-3 px-4 sm:px-6 rounded-md text-base sm:text-lg font-medium block text-center mt-3 sm:mt-4 transition-all hover:shadow-lg"
              >
                Get Started
              </button>
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </div>
  );
};

export default GetStartedLayout;